import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";

const StyledCustomTableDataGrid = styled(DataGrid, {
  shouldForwardProp: (prop) => prop !== "extraDataGridSx" && prop !== "paginationModel",
})<{
  extraDataGridSx: any;
  paginationModel: { page: number; pageSize: number };
}>(({ extraDataGridSx, paginationModel }) => ({
  ...extraDataGridSx,
  border: 0,

  "& .id-column": {
    fontWeight: "200",
  },
  "& .MuiDataGrid-cell:not(.id-column)": {
    color: "black",
    fontWeight: "200",
  },
  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
    outline: "none",
  },
  "& .MuiDataGrid-cell": {
    userSelect: "none",
  },
  "& .MuiDataGrid-columnHeaders": {
    borderRadius: "10px 10px 0 0",
  },
  "& .MuiDataGrid-virtualScrollerContent": {
    minHeight: `calc(51px * ${paginationModel.pageSize} + 10px)`,
  },
  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "#F5FAFF",
    borderRadius: "10px 10px 0 0",
  },
  "& .MuiDataGrid-virtualScroller": {
    overflowX: "auto",
  },
  "& ::-webkit-scrollbar": {
    width: "3px",
    height: "3px",
  },
  "& ::-webkit-scrollbar-thumb": {
    backgroundColor: "#888",
    borderRadius: "10px",
  },
  "& ::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#555",
  },
}));

export default StyledCustomTableDataGrid;
